import { render, staticRenderFns } from "./NotifiedPeopleHealthYN.vue?vue&type=template&id=738963a3"
import script from "./NotifiedPeopleHealthYN.vue?vue&type=script&lang=js"
export * from "./NotifiedPeopleHealthYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports